<app-cart *ngIf="!cartItems.length && !complete"></app-cart>

<div *ngIf="cartItems.length && !complete">
  <mat-card class="stepper-card">
    <ng-container *ngTemplateOutlet="stepper"></ng-container>
  </mat-card>
  <ng-container *ngIf="stepperIndex === 1">
    <retail-shipment-payment (back)="goBack()" (next)="goToCustomerInfo()"></retail-shipment-payment>
  </ng-container>
  <ng-container *ngIf="stepperIndex === 2">
    <retail-customer-info (back)="goBack()" (next)="goToConfirmation()"></retail-customer-info>
  </ng-container>
  <ng-container *ngIf="stepperIndex === 3">
    <retail-final (back)="goBack()" (next)="confirmOrder()"></retail-final>
  </ng-container>
</div>

<div *ngIf="complete">
  <ng-container *ngTemplateOutlet="confirmation"></ng-container>
</div>

<ng-template #stepper>
  <mat-stepper
    [selectedIndex]="stepperIndex"
    [linear]="true"
    (selectionChange)="stepperChange($event)"
    labelPosition="end"
    orientation="horizontal">
    <ng-template matStepperIcon="edit" let-index="index">{{ index + 1 }}</ng-template>
    <mat-step [completed]="true">
      <ng-template matStepLabel
        ><span class="d-none d-md-inline">{{ 'Shopping Cart' | t }}</span></ng-template
      >
    </mat-step>
    <mat-step [stepControl]="shipmentControl">
      <ng-template matStepLabel
        ><span class="d-none d-md-inline">{{ 'Shipment & Payment' | t }}</span></ng-template
      >
    </mat-step>
    <mat-step [stepControl]="infoControl">
      <ng-template matStepLabel
        ><span class="d-none d-md-inline">{{ 'Delivery Info' | t }}</span></ng-template
      >
    </mat-step>
    <mat-step>
      <ng-template matStepLabel
        ><span class="d-none d-md-inline">{{ 'Confirmation' | t }}</span></ng-template
      >
    </mat-step>
  </mat-stepper>
</ng-template>

<ng-template #confirmation>
  <div class="row">
    <div class="col-lg-2"></div>
    <div class="col-lg-8">
      <p>Vážený zákazníku,</p>
      <p>
        děkujeme za Váš nákup, objednávku jsme v pořádku přijali. O jejím zpracování Vás budeme dále informovat
        e-mailem.
      </p>
      <retail-order-info [showButtons]="false" [order]="order"></retail-order-info>
    </div>
  </div>
</ng-template>
